var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { globalComponentExampleState } from './atoms';
import { SelectKVBase } from '@/presentation/components';
import { useRecoilState } from 'recoil';
import React from 'react';
const SelectKV = (_a) => {
    var { name, errorSpan } = _a, props = __rest(_a, ["name", "errorSpan"]);
    const [state, setState] = useRecoilState(globalComponentExampleState);
    return (React.createElement(SelectKVBase, { name: name, label: props.label, state: state, setState: setState, errorSpan: errorSpan }, props.children));
};
export default SelectKV;
